import React from 'react';

export const Layouts = { layout1: React.lazy(() => import('./Layout1/Layout1')) };
